<mat-card>
  <mat-card-content>
    <mat-card-subtitle>{{placeholder()}}</mat-card-subtitle>

    <mat-list>
      <mat-list-item>

        <mat-form-field>
          <mat-label>{{placeholderLabelText}}</mat-label>
          <mat-select [formControl]="elementCtrl" #singleSelect
            (openedChange)="openedChange($event)">
            <mat-option>
              <ngx-mat-select-search [formControl]="elementFilterCtrl"
                placeholderLabel="{{placeholderLabel()}}" noEntriesFoundLabel="no entries found" />
            </mat-option>
            @for (element of filteredListElements | async; track element) {
              <mat-option [value]="element">
                {{element.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

      </mat-list-item>

      @for (element of selectedElementsList; track element) {
        <div>
          <mat-divider [inset]="true" />
          <mat-list-item>
            <p mat-line>{{element.name}}
              <button mat-icon-button (click)="deleteElement(element.id)">
                <mat-icon>close</mat-icon>
              </button>
            </p>
          </mat-list-item>
        </div>
      }

    </mat-list>


  </mat-card-content>
</mat-card>
